import React from 'react';
import classNames from 'classnames';

import Button from 'components/partials/button/button';

interface AdsBlockProps {
  title: string;
  description: string;
  buttonText: string;
  backgroundClass: string;
  isFullWidth?: boolean;
  onButtonClick?: () => void;
}

const AdsBlock = ({
  title,
  description,
  buttonText,
  backgroundClass,
  isFullWidth = false,
  onButtonClick,
}: AdsBlockProps): React.JSX.Element => (
  <div
    className={classNames('rounded-md p-5 overflow-hidden relative w-full', {
      'md:flex-1 h-[260px]': !isFullWidth,
    })}
  >
    <div
      className={classNames(
        'absolute inset-0 bg-cover bg-no-repeat bg-center',
        backgroundClass
      )}
    />

    <div
      className={classNames(
        'relative z-10 flex flex-col justify-between text-white text-left h-full',
        {
          'md:items-center md:text-center': isFullWidth,
        }
      )}
    >
      <div
        className={classNames('w-full', {
          'md:max-w-[800px]': isFullWidth,
          'pr-5': !isFullWidth,
        })}
      >
        <h2 className="text-xl font-bold mb-3">{title}</h2>
        <p className="mb-6">{description}</p>
      </div>
      <div
        className={classNames({
          'md:flex md:justify-center w-full': isFullWidth,
        })}
      >
        <Button onClick={onButtonClick} variant="brand-filled" size="md">
          {buttonText}
        </Button>
      </div>
    </div>
  </div>
);

export default AdsBlock;
